import React from 'react';
import { partial } from 'lodash';
import { Alert } from 'reactstrap';
import { SwitchItem } from '../../Forms/SwitchItem';
import { getTranslationKey } from '../../../modules/utils';
import { SalesCouponSelection } from '../SalesCouponSelection';
import { IShopSalesAutomation } from '../../../modules/types';
import { SWITCH_DIRECTION, SUPPORT_LINKS } from './constants';

interface IProps {
  couponCodeAfterPurchase: IShopSalesAutomation['couponCodeAfterPurchase'];
  isOneCouponUsedTwice: boolean;
  isOneAnniversaryCouponUsedTwice: boolean;
  updateFormValue: (path: string, value: unknown) => void;
}

export const CouponCodeAfterPurchaseSection = React.memo(
  ({
    couponCodeAfterPurchase,
    isOneCouponUsedTwice,
    isOneAnniversaryCouponUsedTwice,
    updateFormValue
  }: IProps) => (
    <>
      <SwitchItem
        value={couponCodeAfterPurchase?.enabled}
        changeCallback={partial(updateFormValue, 'couponCodeAfterPurchase.enabled')}
        label={getTranslationKey('collectionShop.couponCodeAfterLabel')}
        direction={SWITCH_DIRECTION}
        margin="15px 0 5px 0"
        id="couponCodeAfterPurchase-switch"
        withTooltip
        tooltipText={getTranslationKey('learnMoreLink', {
          link: SUPPORT_LINKS.afterPurchase,
          text_link: SUPPORT_LINKS.afterPurchase
        })}
        isIconTooltip
      />

      <SalesCouponSelection
        value={String(couponCodeAfterPurchase?.couponId)}
        changeCallback={partial(updateFormValue, 'couponCodeAfterPurchase.couponId')}
        styles={{
          marginLeft: '38px'
        }}
      />
      {(isOneCouponUsedTwice || isOneAnniversaryCouponUsedTwice) && (
        <Alert color="danger" style={{ marginLeft: '38px' }}>
          {getTranslationKey('collectionShop.couponCannotBeUsedTwice')}
        </Alert>
      )}
    </>
  )
);
